import React, {
  createContext,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
  ReactElement,
} from 'react';
import { IWithChildren } from '../typings/withChildren';

function initializePermissions(): IPermission {
  return {
    canEdit: false,
    hasWorking: false,
    reasonToOtherReason: 1,
    showAddCategories: false,
    showAddTitle: false,
    showBRandsContents: false,
    showBackDate: false,
    showBrandsTitles: false,
    showCountries: false,
    showDynamicFields: false,
    showFeaturedImageLink: false,
    showPagination: false,
    showPermalink: false,
    showPostUrl: false,
    showProductsContents: false,
    showProductsTitles: false,
    showPublishButton: false,
    showPublishNow: false,
    showSendToRevisionButton: false,
    showSiteDomain: false,
    showSitesFilter: false,
    showStatus: false,
    showTag: false,
    showTagsFilter: false,
    showTransferSiteDomain: false,
    showWriters: false,
    showWritersFilter: false,
    statusCanBeOpened: 1,
    statusToRejectReason: 1,
    validations: false,
    showProductType: false,
  };
}

export type IPermissionsContext = [
  IPermission,
  Dispatch<SetStateAction<IPermission>>,
];

export const PermissionsContext = createContext<IPermissionsContext | null[]>([
  null,
]);

export default function PermissionsProvider({
  children,
}: IWithChildren): ReactElement {
  const [permissions, setPermissions] = useState<IPermission>(
    initializePermissions(),
  );

  return (
    <PermissionsContext.Provider value={[permissions, setPermissions]}>
      {children}
    </PermissionsContext.Provider>
  );
}

export function usePermissions(): IPermissionsContext {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('useTitles mus be used within a TitlesProvider');
  }
  return context as IPermissionsContext;
}
